export enum Event {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  STARTPAIRING = "startpairing",
  PAIRED = "paired",
  PAIRERROR = "pairerror",
  SCANNED = "scanned",
  DONE = "done",
  CANCEL = "cancel",
}
